import upperFirst from 'lodash/upperFirst';

const toUpperFirst = (str) => upperFirst(str);

export default toUpperFirst;
